<template>
    <div>
        <h2>箱操作</h2>
        <van-form @submit="onSubmit">
            <van-field v-model="bill.yard_name" label="场地" readonly/>
            <van-field v-model="boxno" name="boxno" maxlength="11" label="箱号" placeholder="箱号" readonly/>
            <van-field readonly clickable required name="area" :value="area" label="箱区" placeholder="点击选择箱区" @click="showArea = true"/>
            <van-popup v-model="showArea" position="bottom">
                <van-picker show-toolbar :columns="area_list" @confirm="onAreaConfirm" @cancel="showArea = false"/>
            </van-popup>
            <van-divider>箱子详细信息</van-divider>
            <van-field v-model="bill.box_weight" name="box_weight" label="空重箱" readonly/>
            <van-field v-model="bill.box_model" name="box_model" label="箱型" readonly/>
            <van-field v-model="bill.tel" name="tel" label="落箱司机电话" readonly/>
            <van-field v-model="bill.in_carno" name="in_carno" label="落箱司机车牌" readonly/>
            <van-field v-model="bill.out_tel" name="out_tel" label="提箱司机电话" readonly/>
            <van-field v-model="bill.out_carno" name="out_carno" label="提箱司机车牌" readonly/>
            <van-field v-model="bill.neardate" name="neardate" label="进港时间" readonly/>
            <van-field v-model="bill.shipname" name="shipname" label="码头船名" readonly/>
            <van-field v-model="bill.voyage" name="voyage" label="码头航次" readonly/>
            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">提交</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Dialog, Form, Picker} from 'vant';

    Vue.use(Picker);
    Vue.use(Form);

    export default {
        data() {
            return {
                id: '',
                boxno: '',
                bill: '',
                yard_name: '芦潮港（同汇路908号）',
                yard_id: 0,
                yard_list: [],
                showPicker: false,
                area: '',
                area_list: [{values:['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']},{values: ['1','2','3','4','5','6','7','8','9']}],
                showArea: false,
                type: '',
            };
        },
        methods: {
            onConfirm(value, index) {
                this.yard_name = value;
                this.yard_id = index;
                this.showPicker = false;
            },
            onAreaConfirm(value, index) {
                this.area = value[0]+value[1];
                this.showArea = false;
            },
            onSubmit(values) {
                let querystring = require("querystring");
                this.$api.post("wx/box-manage/form",
                    querystring.stringify({
                        boxno: this.boxno,
                        area: this.area,
                        type: this.type,
                        yard_name: this.yard_name,
                        yard_id: this.yard_id,
                        tel: localStorage.getItem("tel"),
                    })
                ).then(({data}) => {
                    if (data.status == 1) {
                        Dialog.alert({
                            message: data.msg,
                        }).then(() => {
                            this.$router.push({path: "/box-manage/home"});
                        });
                    } else {
                        Dialog.alert({
                            message: data.msg,
                        }).then(() => {
                        });
                    }
                });
            },
            getBillInfo() {
                let querystring = require('querystring');
                this.$api.post('wx/container-yard/billInfo',
                    querystring.stringify({
                        id: this.id,
                    })
                ).then(data => {
                    if (data.data.status == 1) {
                        this.bill = data.data.data;
                        this.area = this.bill.area;
                    } else {
                        Dialog.alert({
                            message: data.data.msg,
                        }).then(() => {

                        });
                    }
                }).catch(err => {
                    console.log(err);
                })
            }
        },
        mounted() {
            this.id = this.$route.query.id;
            this.getBillInfo();
            this.boxno = this.$route.query.boxno;
            this.type = this.$route.query.type;
        }
    }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/box-manage/form.vue